import { Show as ChakraShow, ShowProps } from '@chakra-ui/react-v2';

/** The same as Chakra's `Show`, but with the SSR option defaulting to false so that it returns the correct value on the first render. */
export const Show = ({ ssr = false, ...props }: ShowProps) => {
  return <ChakraShow ssr={ssr} {...props} />;
};
